import { on } from 'delegated-events';
import { debounce } from '../utils/utils';

const body = document.body;
let winWidth = window.innerWidth;

export default function () {

    let updateWidth = debounce(function () {
        winWidth = window.innerWidth;
    }, 100);

    window.addEventListener('resize', () => {
        updateWidth();
    });


    initTree();

    initSearchBox();

    suppressTransitionsOnBreakpoint();
}

// przejscie przez 1280px przelacza menu, kanwy i kolumne filtrow miedzy wersja mobilna a desktopowa;
// ich przejscia CSS (np. zanik menu "Produkty" z opoznieniem) odtwarzalyby sie wtedy na oczach -
// na moment przelaczenia wylaczamy je klasa na <html> (regula w atf_base)
function suppressTransitionsOnBreakpoint() {
    const root = document.documentElement;
    let timer = null;

    window.matchMedia('(min-width: 1280px)').addEventListener('change', () => {
        root.classList.add('breakpoint-switch');
        clearTimeout(timer);
        timer = setTimeout(() => root.classList.remove('breakpoint-switch'), 300);
    });
}

function initTree() {
    const tree = document.getElementById('tree');
    if (!tree) return;

    initTreeTogglers();
    initRwdTree();
}

function initTreeTogglers() {
    document.querySelector('.tree-trigger').addEventListener('click', function (e) {
        if (winWidth < 1280) {
            e.stopPropagation();

            if (!tree.querySelector('.close-tree-header')) {
                tree.firstElementChild.firstElementChild.insertAdjacentHTML('afterbegin', '<li class="tree-header-item"><span class="tree-header close-tree-header"><span>Menu</span></span></li>');
            }

            const menuRwdWrapper = document.querySelector('.cms-rwd.menu-rwd');
            const mainmenu = document.querySelector('.mainmenu');
            if (mainmenu && menuRwdWrapper && menuRwdWrapper.innerHTML === '') {
                menuRwdWrapper.innerHTML = mainmenu.innerHTML;
            }

            const topmenuRwdWrapper = document.querySelector('.cms-rwd.topmenu-rwd');
            const topmenu = document.querySelector('.top-bar-menu');
            if (topmenu && topmenuRwdWrapper && topmenuRwdWrapper.innerHTML === '') {
                topmenuRwdWrapper.innerHTML = topmenu.innerHTML;
            }

            body.classList.toggle('show-menu');
        }
    });

    document.querySelector('.tree-canvas').addEventListener('click', function () {
        body.classList.remove('show-menu');
    });

    on('click', '#tree .close-tree-header', function () {
        body.classList.remove('show-menu');
    });
}

function initRwdTree() {
    on('click', '#tree .category-header', function (e) {
        if (winWidth < 1280) {
            e.preventDefault();

            const closestUl = this.closest('ul');
            const wrappingUl = closestUl.parentElement.parentElement;

            closestUl.classList.remove('active');
            wrappingUl.classList.remove('hide');
        }
    });

    on('click', '#tree a', function (e) {
        if (winWidth < 1280) {
            if (this.parentElement.classList.contains('parent')) {
                e.preventDefault();

                const nextUl = this.nextElementSibling;
                const closestUl = this.closest('ul');

                closestUl.classList.add('hide');
                nextUl.classList.add('active');
                nextUl.scrollIntoView();
            }
        }
    });
}

function initSearchBox() {
    let search = document.querySelector('#search-engine');
    const searchEngineTrigger = document.querySelector('.search-engine-trigger');
    const searchEngineClose = document.querySelector('.search-engine-close');
    if (!search || !searchEngineTrigger || !searchEngineClose) return;

    searchEngineTrigger.addEventListener('click', function () {
        body.classList.toggle('overlay-visible');
        body.classList.toggle('show-search-engine');
        search.querySelector('input[name="query"]').focus();
    });

    searchEngineClose.addEventListener('click', function () {
        body.classList.remove('overlay-visible');
        body.classList.remove('show-search-engine');
    });

    document.addEventListener('click', function (e) {
        const clickedInside = search.contains(e.target);
        const clickedTrigger = searchEngineTrigger.contains(e.target);

        if (!clickedTrigger && !clickedInside && window.outerWidth > 1279) {
            body.classList.remove('overlay-visible');
            body.classList.remove('show-search-engine');
        }
    });
}